export default __webpack_public_path__ + "static/media/ToggleGroup.db3f21d0.less";